<template>
  <vs-row id="invoice-page">
    <vs-col vs-w="12">
      <ShowPreventivo
        :selected="selected"
        :stati="this.stati"
        :button_bar="true"
        @email-me="inviaDoc"
        @close-me="closeSidebar"
        @stato-avanzato="commitStato"
        :logo="this.logoString"
      />
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'
import ShowPreventivo from './ShowPreventivo.vue'

export default {
  data() {
    return {
      componentKey: 0,
      utente_nome: "",
      utente_id: "",
      popupActivo: false,
      display_logo: "",
      popupStato: false,
      avanza_stato: 0,
      return_logo_string: 'CEDASCOM',
    }
  },
  components: {
    ShowPreventivo
  },
  props: {
    selected: Object,
    stati: Array,
    active: Boolean,
  },
  computed: {
    logoString() {
      if (this.selected && this.selected.voci.length) return this.$tariffe.returnLogoString(this.selected)
      else this.return_logo_string
    },
  },
  methods: {
    closeSidebar() {
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      this.$emit('close-me')
    },
    inviaDoc() {
      this.$emit('email-me',this.selected.id)
    },
    commitStato() {
      this.$emit('stato-avanzato')
    },
  },
}
</script>
<style>
.quill {
  width: 100%;
}
</style>
